import { Theme } from '@mui/material';
import { CSSProperties } from 'react';

const getAgGridMuiStyles = (
  theme: Theme
): CSSProperties & Record<string, unknown> => {
  const agVars = {
    '--ag-font-family': theme.typography.fontFamily,
    '--ag-font-size': '13.5px',

    '--ag-header-foreground-color': theme.palette.text.secondary,
    '--ag-foreground-color': theme.palette.text.primary,
    '--ag-background-color': theme.palette.background.paper,
    '--ag-border-color': theme.palette.divider,

    '--ag-header-height': '56px',
    '--ag-header-background-color': theme.palette.background.paper,

    '--ag-row-height': '56px',
    '--ag-row-border-color': theme.palette.divider,
    '--ag-row-hover-color':
      theme.palette.mode === 'dark'
        ? 'rgba(255,255,255,0.04)'
        : 'rgba(0,0,0,0.03)',

    '--ag-selected-row-background-color': theme.palette.action.selected,
  } as CSSProperties;

  return {
    ...agVars,

    '& .ag-header': {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },

    '& .ag-header-cell': {
      fontWeight: 500,
      fontSize: theme.typography.pxToRem(13),
      letterSpacing: '0.3px',
      paddingLeft: theme.spacing(2.5),
    },

    '& .ag-header-cell::after': {
      display: 'none',
    },

    '& .ag-row': {
      cursor: 'pointer',
    },

    '& .ag-row:first-of-type': {
      borderTop: `1px solid ${theme.palette.divider}`,
    },

    '& .ag-cell:focus': {
      outline: 'none',
    },

    '& .ag-cell-focus': {
      border: 'none !important',
    },

    '& .ag-pinned-left-header, & .ag-pinned-right-header': {
      boxShadow: 'none',
    },

    '& .ag-pinned-left-cols-container, & .ag-pinned-right-cols-container': {
      boxShadow: 'none',
    },

    '& .ag-paging-panel': {
      borderTop: `1px solid ${theme.palette.divider}`,
    },
  };
};

const getAgGridContainerStyles = (
  theme: Theme
): CSSProperties & Record<string, unknown> => ({
  height: '100%',
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(1.5),
  boxShadow: theme.shadows[3],
  overflow: 'hidden',
});

export const agGridMuiTheme = getAgGridMuiStyles;

export const agGridMuiGlobalStyles = (theme: Theme) => ({
  '.ag-theme-quartz': getAgGridMuiStyles(theme),
  '.MuiPaper-root.ag-theme-quartz': getAgGridContainerStyles(theme),
});
